<template>
  <div class="compare-slider">
    <div class="sheet-panel compare-select">
      <div class="sheet-content">
        <h3>Compare</h3>
        <div class="select-list">
          <div
            v-bind:key="person.lastName"
            v-for="person in masterCompare"
            class="focus-person"
            v-bind:class="{ focused: person === activeItem }"
            @click="setFocus(person)"
          >
            {{ person.firstName }} {{ person.lastName }}
          </div>
        </div>
        <button @click="toggleCompareModal" class="btn btn-primary">
          Select friends
        </button>
      </div>
    </div>

    <div class="sheet-panel compare-panel">
      <div class="sheet-content ope">
        <h3>Openness</h3>
        <div class="band-container ope">
          <div class="timeline">
            <div class="timeline-inner">
              <span class="start"></span>
              <span class="end"></span>
              <div
                v-bind:key="person.lastName"
                v-for="person in masterCompare"
                class="person"
                v-bind:class="{ focused: person === activeItem }"
                v-bind:style="{ left: person.personality.scores.ope + '%' }"
                @click="setFocus(person)"
              >
                <span class="minitip">{{ person.firstName }}</span>
              </div>
            </div>
          </div>
          <div class="description">
            <div class="start">
              <h4>Practical</h4>
              <span class="desc">(pragmatic, traditional)</span>
            </div>
            <div class="end">
              <h4>Explorer</h4>
              <span class="desc">(curious, creative)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sheet-panel compare-panel">
      <div class="sheet-content con">
        <h3>Conscientiousness</h3>
        <div class="band-container con">
          <div class="timeline">
            <div class="timeline-inner">
              <span class="start"></span>
              <span class="end"></span>
              <div
                v-bind:key="person.lastName"
                v-for="person in masterCompare"
                class="person"
                v-bind:class="{ focused: person === activeItem }"
                v-bind:style="{ left: person.personality.scores.con + '%' }"
                @click="setFocus(person)"
              >
                <span class="minitip">{{ person.firstName }}</span>
              </div>
            </div>
          </div>
          <div class="description">
            <div class="start">
              <h4>Spontaneous</h4>
              <span class="desc">(flexible, unorthodox)</span>
            </div>
            <div class="end">
              <h4>Focused</h4>
              <span class="desc">(perservering, organised)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sheet-panel compare-panel">
      <div class="sheet-content ext">
        <h3>Extraversion</h3>
        <div class="band-container ext">
          <div class="timeline">
            <div class="timeline-inner">
              <span class="start"></span>
              <span class="end"></span>
              <div
                v-bind:key="person.lastName"
                v-for="person in masterCompare"
                class="person"
                v-bind:class="{ focused: person === activeItem }"
                v-bind:style="{ left: person.personality.scores.ext + '%' }"
                @click="setFocus(person)"
              >
                <span class="minitip">{{ person.firstName }}</span>
              </div>
            </div>
          </div>
          <div class="description">
            <div class="start">
              <h4>Introverted</h4>
              <span class="desc">(reserved, private)</span>
            </div>
            <div class="end">
              <h4>Extroverted</h4>
              <span class="desc">(social, energetic)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sheet-panel compare-panel">
      <div class="sheet-content agr">
        <h3>Agreeableness</h3>
        <div class="band-container agr">
          <div class="timeline">
            <div class="timeline-inner">
              <span class="start"></span>
              <span class="end"></span>
              <div
                v-bind:key="person.lastName"
                v-for="person in masterCompare"
                class="person"
                v-bind:class="{ focused: person === activeItem }"
                v-bind:style="{ left: person.personality.scores.agr + '%' }"
                @click="setFocus(person)"
              >
                <span class="minitip">{{ person.firstName }}</span>
              </div>
            </div>
          </div>
          <div class="description">
            <div class="start">
              <h4>Challenger</h4>
              <span class="desc">(competitive, self focused)</span>
            </div>
            <div class="end">
              <h4>Accomodating</h4>
              <span class="desc">(supportive, harmonious)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sheet-panel compare-panel">
      <div class="sheet-content neu">
        <h3>Neuroticism</h3>
        <div class="band-container neu">
          <div class="timeline">
            <div class="timeline-inner">
              <span class="start"></span>
              <span class="end"></span>
              <div
                v-bind:key="person.lastName"
                v-for="person in masterCompare"
                class="person"
                v-bind:class="{ focused: person === activeItem }"
                v-bind:style="{ left: person.personality.scores.neu + '%' }"
                @click="setFocus(person)"
              >
                <span class="minitip">{{ person.firstName }}</span>
              </div>
            </div>
          </div>
          <div class="description">
            <div class="start">
              <h4>Resilient</h4>
              <span class="desc">(even tempered, calm)</span>
            </div>
            <div class="end">
              <h4>Reactive</h4>
              <span class="desc">(emotional, moody)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal modal-compare" id="compareModal">
      <div class="modal-wrap">
        <div class="sheet-panel">
          <div class="sheet-header">
            <h3>Select friends to compare</h3>
            <button
              @click="refreshFriends"
              class="btn btn-tertiary btn-sm"
              v-bind:class="{ disabled: refreshCooldown }"
              style="margin-left: 15px;"
            >
              <span
                ><font-awesome-icon icon="sync" style="margin-right: 4px" />
                Refresh</span
              >
            </button>
            <button @click="toggleCompareModal" class="close-modal">
              <font-awesome-icon icon="times" />
            </button>
          </div>
          <div class="sheet-content">
            <div class="scroll-container">
              <div class="row friends compare">
                <div v-if="getFriends == ''" class="col-12 no-friends">
                  <img src="@/assets/no_friends.svg" />
                  <div class="content">
                    <h4>You have no friends yet</h4>
                    <p>Let's invite some friends!</p>
                  </div>
                </div>
                <div
                  v-bind:key="friend.id"
                  v-for="friend in fetchedFriends"
                  class="col-md-6"
                >
                  <div
                    class="friend"
                    @click="selectFriends(friend.data)"
                    v-bind:class="{
                      focused: selectedFriends.includes(friend.data),
                    }"
                  >
                    <div class="friend-avatar">
                      <img src="/avatar.png" class="squirkle" alt />
                    </div>
                    <div class="friend-content">
                      <span class="name"
                        >{{ friend.data.firstName }}
                        {{ friend.data.lastName }}</span
                      >
                      <div class="ring"><font-awesome-icon icon="check" /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 offset-md-3">
                <button
                  v-if="getFriends == ''"
                  @click="toggleCompareModal(), $toggleFriendsModal()"
                  class="btn btn-primary btn-auth btn-loader"
                >
                  <span>Invite friends</span>
                </button>
                <button
                  v-else
                  @click="toggleCompareModal"
                  class="btn btn-primary btn-auth btn-loader"
                >
                  <span>Compare friends</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../main.js";

import { mapState } from "vuex";
var _ = require("lodash");

export default {
  name: "CompareSlider",
  components: {},
  props: {
    sets: Array,
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["friends"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    getFriends() {
      return this.friends ? this.friends : "";
    },
    activeFriends() {
      return _.filter(this.getFriends, { status: true });
    },
    masterCompare() {
      let users = [];
      users.push(this.userData);
      users = users.concat(this.selectedFriends);
      //console.log(users);
      return users;
    },
  },
  data() {
    return {
      activeItem: null,
      inviteEmailAddress: "",
      loading: false,
      success: false,
      fetchedFriends: [],
      selectedFriends: [],
      refreshCooldown: false,
    };
  },
  mounted: function() {
    this.activeItem = this.userData;
    this.getAllFriendsData();
  },
  methods: {
    setFocus: function(item) {
      this.activeItem = item;
    },
    refreshFriends() {
      this.refreshCooldown = true;
      this.getAllFriendsData();
      setTimeout(() => {
        this.refreshCooldown = false;
      }, 3000);
    },
    initials: function(firstName, lastName) {
      let initials = "";
      if (firstName && lastName) {
        initials = firstName.charAt(0) + lastName.charAt(0);
      }
      return initials;
    },
    getAllFriendsData() {
      const friendsData = [];
      this.activeFriends.forEach((element) => {
        let friendRef = db
          .collection("users")
          .doc(element.id)
          .collection("shared")
          .doc(element.id);
        friendRef
          .get()
          .then((doc) => {
            let data = doc.data();
            let id = element.id;
            let output = { id: id, data: data };

            if (data && data.hasOwnProperty("personality")) {
              friendsData.push(output);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
      this.fetchedFriends = friendsData;
    },
    toggleCompareModal() {
      const compareModal = document.getElementById("compareModal");
      compareModal.classList.toggle("toggled");
    },
    selectFriends(item) {
      if (this.selectedFriends.includes(item)) {
        var index = this.selectedFriends.indexOf(item);
        if (index !== -1) this.selectedFriends.splice(index, 1);
      } else {
        if (this.selectedFriends.length < 5) {
          this.selectedFriends.push(item);
        }
      }
    },
  },
};
</script>
